(function() {
    'use strict';

    function PaginationController(PaginationService) {
        var vm = this;

        vm.currentPage = 1;
        vm.totalPages = 1;
        vm.lastPage = 1;
        vm.nextPage = 1;
        vm.prevPage = 0;
        vm.pages = [];

        vm.isActive = function(type) {
            var isActive = false;

            switch (type) {
                case 'first':
                    isActive = vm.lastPage > 1 && vm.currentPage > 1;
                    break;
                case 'prev':
                    isActive = vm.prevPage > 0 && vm.currentPage > 1;
                    break;
                case 'next':
                    isActive = vm.nextPage <= vm.lastPage && vm.currentPage !== vm.lastPage;
                    break;
                case 'last':
                    isActive = vm.lastPage > 1 && vm.currentPage < vm.totalPages;
                    break;
            }

            return isActive;
        };

        vm.goToPage = function(page, type) {
            var set = true;

            if (!_.isUndefined(type)) {
                set = vm.isActive(type);
            }

            if (set && vm.currentPage !== page) {
                vm.currentPage = page;
                vm.prevPage = Math.max(page - 1, 0);
                vm.nextPage = Math.min(page + 1, vm.lastPage + 1);

                vm.setPage({ value: page - 1 });
            }
        };

        vm.$onChanges = function() {
            vm.currentPage = vm.config.page + 1;

            vm.totalPages = Math.ceil(vm.config.totalElements / vm.config.size);
            vm.lastPage = vm.config.totalElements > 0 ? Math.ceil(vm.config.totalElements / vm.config.size) : 1;
            vm.nextPage = Math.max(2, Math.min(vm.currentPage + 1, vm.lastPage));
            vm.prevPage = Math.max(0, vm.currentPage - 1);

            vm.pages = PaginationService.getPages(vm.currentPage, vm.config.totalElements, vm.totalPages);
        };
    }

    angular.module('remitEventsApp').component('mriPagination', {
        templateUrl: 'scripts/components/pagination/pagination.html',
        controller: PaginationController,
        controllerAs: 'pagination',
        bindings: {
            config: '<',
            setPage: '&'
        }
    });
})();
